import styled from "@emotion/styled";
import React from "react";
import { StatusTag } from "../StatusTag";
import { Typography } from "../Typography";
import { StatusVariant } from "@ecologi/shared";

const StyledButton = styled.button<{ opaque: boolean }>`
  all: unset;
  background-color: ${(props) =>
    props.opaque
      ? props.theme.colors.opacity(props.theme.colors.snowdrop, 0.2)
      : props.theme.colors.snowdrop};
  height: 60px;
  border-radius: 44px;
  padding: 0 18px 0 18px;
  cursor: pointer;
  :focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.forest}`};
  }
`;

const ButtonContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

type Props = {
  label: string;
  variant?: StatusVariant;
  rightIcon?: React.ReactNode;
  onClick: () => void;
  className?: string;
  tagLabel?: string;
  opaque?: boolean;
};

export const NewFeatureButton = ({
  label,
  variant = "bold",
  tagLabel = "New",
  opaque = false,
  rightIcon,
  onClick,
  className,
}: Props) => (
  <StyledButton className={className} onClick={onClick} opaque={opaque}>
    <ButtonContent>
      <StatusTag variant={variant} label={tagLabel} />
      <Typography use="dashboardStandaloneLink">{label}</Typography>
      {rightIcon}
    </ButtonContent>
  </StyledButton>
);
